import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MarqueeProps extends ComponentPropsWithoutRef<"div"> {
  className?: string;
  /** Reverse the animation direction */
  reverse?: boolean;
  /** Pause the animation on hover */
  pauseOnHover?: boolean;
  /** Animate vertically instead of horizontally */
  vertical?: boolean;
  /** Number of times to repeat the content */
  repeat?: number;
  children: ReactNode;
}

export function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  vertical = false,
  repeat = 4,
  children,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={cn(
        "marquee flex gap-[var(--gap)] overflow-hidden p-1 [--duration:40s] [--gap:1rem]",
        vertical ? "flex-col" : "flex-row",
        pauseOnHover && "pause-on-hover",
        className
      )}
    >
      {Array.from({ length: repeat }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "marquee-track flex w-max shrink-0 justify-around gap-[var(--gap)]",
            vertical ? "is-vertical flex-col" : "flex-row",
            reverse && "is-reverse"
          )}
        >
          {children}
        </div>
      ))}
    </div>
  );
}